<template>
  <div>
    <label v-if="label" class="  ">{{ input.display_name }}</label>
    <component
      :form="form"
      :is="type"
      :label="label"
      :value="value"
      :input="input"
    ></component>
  </div>
</template>

<script>
export default {
  props: ["input", "type", "form", "label", "value"],

  components: {
    icon: () => import(`../Ui/Form/icon`),
    id: () => import(`../Ui/Form/id`),
    json: () => import(`../Ui/Form/json`),
    modal: () => import(`../Ui/Form/id`),
    date: () => import(`../Ui/Form/date`),
    datetime: () => import(`../Ui/Form/datetime`),
    string: () => import(`../Ui/Form/string`),
    clickShow: () => import(`../Ui/Form/clickShow`),
    editableDate: () => import(`../Ui/Form/editableDate`),
    birthday: () => import(`../Ui/Form/birthday`),
    name: () => import(`../Ui/Form/string`),
    lead_id: () => import(`../Ui/Form/lead_id`),
    color: () => import(`../Ui/Form/color`),
    textField: () => import(`../Ui/Form/textField`),
    leadStatus: () => import(`../Ui/Form/leadStatus`),
    selectbox: () => import(`../Ui/Form/selectBox.vue`),
    multipleSelect: () => import(`../Ui/Form/multipleSelect.vue`),
    status: () => import(`../Ui/Form/status`),
    integer: () => import(`../Ui/Form/integer`),
    double: () => import(`../Ui/Form/double`),
    email: () => import(`../Ui/Form/email`),
    password: () => import(`../Ui/Form/password`)
  }
};
</script>

<style></style>
